<main role="main" >
    <section>
        <article>
            <app-labo-header></app-labo-header>
            <app-labo-content></app-labo-content>
        </article>
    </section>
</main>